import includes from "lodash/includes"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import { affective, multiple } from "../../actions/types"
import entity from "../entity"

const INITIAL_STATE = {}

export default function entitiesReducer(state = INITIAL_STATE, action) {
  if (includes(affective, action.type)) {
    const { model } = action

    const { name } = normalizeModel(model)

    /* Handle batch actions */
    if (action.type === multiple.batch) {
      const { actions } = action
      let nextState = state
      for (let i = 0; i < actions.length; i += 1) {
        const nextEntity = entity(nextState[name], actions[i])
        if (nextEntity !== nextState[name]) {
          nextState = {
            ...nextState,
            [name]: nextEntity,
          }
        }
      }

      return nextState
    }

    const nextEntity = entity(state[name], action)

    return nextEntity !== state[name]
      ? {
          ...state,
          [name]: nextEntity,
        }
      : state
  }
  return state
}
